namespace $.$$ {

	type $shm_hitalama_settings_tauri_config = {
		selfhosted_tauri?: boolean
		port?: number
		actual_port?: number
		port_occupied?: number
		domain_link?: string
		domain?: string
		master?: string
		tunnel_enabled?: boolean
		ssh_host?: string
		ssh_user?: string
		ssh_port?: number
		remote_port?: number
		ssh_key?: string
		tunnel_status?: string
	}

	export class $shm_hitalama_settings extends $.$shm_hitalama_settings {

		static selfhosted_tauri_enabled(): boolean {
			const key = `${ this }.selfhosted_tauri_enabled`
			const arg = Boolean(
				this.$.$mol_state_arg.value( 'tauri_port' )
				|| this.$.$mol_state_arg.value( 'tauri_port_occupied' )
				|| this.$.$mol_state_arg.value( 'selfhosted_tauri' )
			)
			if( arg ) this.$.$mol_state_local.value( key, true )
			if( !this.tauri_available() ) return false
			const config = this.$.$mol_error_fence(
				()=> this.tauri_config(),
				()=> null,
				()=> null,
			)
			if( config?.selfhosted_tauri ) this.$.$mol_state_local.value( key, true )
			return this.$.$mol_state_local.value< boolean >( key ) ?? false
		}

		static tauri_arg< Value >( name: string, next?: Value ) {
			const key = `${ this }.${ name }.arg`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next )
			const arg = this.$.$mol_state_arg.value( name )
			if( arg !== null ) return this.$.$mol_state_local.value( key, arg )
			return this.$.$mol_state_local.value< Value >( key )
		}

		static tauri_config_uri() {
			return '/hitalama_tauri_config'
		}

		static tauri_available() {
			return Boolean(
				this.$.$mol_state_arg.value( 'tauri_port' )
				|| this.$.$mol_state_arg.value( 'tauri_port_occupied' )
				|| this.$.$mol_state_arg.value( 'selfhosted_tauri' )
				|| ( globalThis as any ).__TAURI__
				|| ( globalThis as any ).__TAURI_INTERNALS__
			)
		}

		@ $mol_mem
		static tauri_config( next?: $shm_hitalama_settings_tauri_config ): $shm_hitalama_settings_tauri_config {
			if( next ) return next
			if( !this.tauri_available() ) return { selfhosted_tauri: false }
			return this.$.$mol_fetch.json( this.tauri_config_uri() ) as $shm_hitalama_settings_tauri_config
		}

		static tauri_field< Value >( name: string, next: Value | undefined, fallback: Value ) {
			const key = `${ this }.${ name }`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? fallback
			const local = this.$.$mol_state_local.value< Value >( key )
			if( local !== undefined && local !== null ) return local
			const config = this.$.$mol_error_fence(
				()=> this.tauri_config(),
				()=> ({} as $shm_hitalama_settings_tauri_config),
				()=> ({} as $shm_hitalama_settings_tauri_config),
			)
			return ( config as any )[ name ] ?? fallback
		}

		tauri_config() {
			return $shm_hitalama_settings.tauri_config()
		}

		selfhosted_tauri_link() {
			return $shm_hitalama_settings.selfhosted_tauri_enabled() ? this.Selfhosted_tauri_link() : null
		}

		selfhosted_tauri_content() {
			return $shm_hitalama_settings.selfhosted_tauri_enabled() ? [ this.Selfhosted_tauri_config() ] : []
		}

		tauri_port_conflict_message() {
			const occupied = Number( $shm_hitalama_settings.tauri_arg( 'tauri_port_occupied' ) || 0 )
			if( !occupied ) return ''
			return `Порт ${ occupied } занят. Приложение запущено на ${ $shm_hitalama_settings.tauri_arg( 'tauri_port' ) }.`
		}

		tauri_port_conflict_message_visible() {
			return this.tauri_port_conflict_message() ? [ this.Tauri_port_conflict_message() ] : []
		}

		tauri_port( next?: number ) {
			if( next !== undefined ) return $shm_hitalama_settings.tauri_field( 'port', next, 9090 )
			return $shm_hitalama_settings.tauri_field( 'port', next, Number( $shm_hitalama_settings.tauri_arg( 'tauri_port_occupied' ) || 9090 ) )
		}

		tauri_domain( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'domain', next, '' )
		}

		tauri_master( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'master', next, '' )
		}

		tauri_tunnel_enabled( next?: boolean ) {
			return $shm_hitalama_settings.tauri_field( 'tunnel_enabled', next, false )
		}

		tauri_ssh_host( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_host', next, '' )
		}

		tauri_ssh_user( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_user', next, '' )
		}

		tauri_ssh_port( next?: number ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_port', next, 22 )
		}

		tauri_remote_port( next?: number ) {
			return $shm_hitalama_settings.tauri_field( 'remote_port', next, 80 )
		}

		tauri_ssh_key( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_key', next, '' )
		}

		@ $mol_mem
		tauri_save_message( next?: string ) {
			return next ?? ''
		}

		@ $mol_action
		tauri_save( next?: any ) {
			const config: $shm_hitalama_settings_tauri_config = {
				port: Number( this.tauri_port() ) || 9090,
				domain: this.tauri_domain(),
				master: this.tauri_master(),
				tunnel_enabled: this.tauri_tunnel_enabled(),
				ssh_host: this.tauri_ssh_host(),
				ssh_user: this.tauri_ssh_user(),
				ssh_port: Number( this.tauri_ssh_port() ) || 22,
				remote_port: Number( this.tauri_remote_port() ) || 80,
				ssh_key: this.tauri_ssh_key(),
			}

			const saved = this.$.$mol_fetch.json( $shm_hitalama_settings.tauri_config_uri(), {
				method: 'PUT',
				headers: { 'content-type': 'application/json' },
				body: JSON.stringify( config ),
			} ) as $shm_hitalama_settings_tauri_config

			$shm_hitalama_settings.tauri_config( saved )
			this.tauri_save_message( 'Сохранено. Порт применится после перезапуска приложения, SSH-туннель перезапускается автоматически.' )
		}

		static mic( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.mic', next ) ?? ''
		}

		static speaker( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.speaker', next ) ?? ''
		}

		static agent_settings( next?: {
			url?: string
			token?: string
		} ): {
			url?: string
			token?: string
		} {
			type Agent_settings = {
				url?: string
				token?: string
			}

			const profile = this.$.$shm_hitalama_profile.current()
			if( profile ) {
				const prev = this.$.$mol_error_fence(
					()=> ( profile.store( 'agent_settings' ) ?? {} ) as Agent_settings,
					()=> ({}),
					promise => promise,
				)
				if( next !== undefined ) return this.$.$mol_error_fence(
					()=> profile.store( 'agent_settings', {
					... prev,
					... next,
					} ) as Agent_settings,
					()=> ({
						... prev,
						... next,
					}),
					promise => promise,
				)
				return prev
			}

			if( next?.url !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_url', next.url )
			if( next?.token !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_token', next.token )
			return {
				url: this.$.$mol_state_local.value< string >( 'hitalama_agent_url' ) ?? '',
				token: this.$.$mol_state_local.value< string >( 'hitalama_agent_token' ) ?? '',
			}
		}

		static agent_url_default(): string {
			const location = this.$.$mol_dom_context.document?.location
			if( location?.protocol === 'https:' && location.hostname.includes( '158-160-195-195' ) ) {
				return 'https://opencode.158-160-195-195.ip.hyoo.ru'
			}
			return ''
		}

		static agent_url( next?: string ): string {
			if( next !== undefined ) return String( this.agent_settings({ url: next }).url ?? '' )
			const stored = String(
				this.agent_settings().url
				?? this.$.$mol_state_local.value< string >( 'hitalama_agent_url' )
				?? ''
			).trim()
			return stored || this.agent_url_default()
		}

		static agent_token( next?: string ): string {
			if( next !== undefined ) return String( this.agent_settings({ token: next }).token ?? '' )
			return String(
				this.agent_settings().token
				?? this.$.$mol_state_local.value< string >( 'hitalama_agent_token' )
				?? ''
			)
		}

		mic( next?: string ): string {
			return $shm_hitalama_settings.mic( next )
		}

		speaker( next?: string ): string {
			return $shm_hitalama_settings.speaker( next )
		}

		agent_url( next?: string ): string {
			return $shm_hitalama_settings.agent_url( next )
		}

		agent_token( next?: string ): string {
			return $shm_hitalama_settings.agent_token( next )
		}

		@ $mol_mem
		microphones() {
			const devices = $mol_wire_sync( navigator.mediaDevices ).enumerateDevices()
			const microphones = devices.filter( device => device.kind === 'audioinput' )

			const dict: Record< string, string > = {
				'': 'По умолчанию',
			}
			microphones.forEach( ( mic, index )=> {
				dict[ mic.deviceId ] = `${ index }: ${ mic.label || 'Без названия' }`
			} )

			return dict
		}

		static stick_px( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.stick_px', next ) ?? 200
		}

		stick_px( next?: number ): number {
			return $shm_hitalama_settings.stick_px( next )
		}

		static widget_float_resizer_size( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.widget_float_resizer_size', next ) ?? 10
		}

		widget_float_resizer_size( next?: number ): number {
			return $shm_hitalama_settings.widget_float_resizer_size( next )
		}

		static widget_keyboard_move_step_px( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.widget_keyboard_move_step_px', next ) ?? 1
		}

		widget_keyboard_move_step_px( next?: number ): number {
			return $shm_hitalama_settings.widget_keyboard_move_step_px( next )
		}

		static slideshow_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.slideshow_mode_key', next ) ?? ''
		}

		slideshow_mode_key( next?: string ): string {
			return $shm_hitalama_settings.slideshow_mode_key( next )
		}

		static fullscreen_disable_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.fullscreen_disable_key', next ) ?? 'Escape'
		}

		fullscreen_disable_key( next?: string ): string {
			return $shm_hitalama_settings.fullscreen_disable_key( next )
		}

		static drag_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.drag_mode_key', next ) ?? 'Control'
		}

		drag_mode_key( next?: string ): string {
			return $shm_hitalama_settings.drag_mode_key( next )
		}

		static drawing_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.drawing_mode_key', next ) ?? 'P'
		}

		drawing_mode_key( next?: string ): string {
			return $shm_hitalama_settings.drawing_mode_key( next )
		}

		static dragger_keep_size( next?: boolean ): boolean {
			return this.$.$mol_state_local.value( this+'.dragger_keep_size', next ) ?? true
		}

		dragger_keep_size( next?: boolean ): boolean {
			return $shm_hitalama_settings.dragger_keep_size( next )
		}

		overlayed_map() {
			return $shm_hitalama_profile.current()?.overlayed_map() ?? null
		}

		@ $mol_mem
		overlayed_map_enabled( next?: boolean ): boolean {
			return $shm_hitalama_profile.current()?.overlayed_map_enabled( next ) ?? false
		}

		template_map( id: string ) {
			const profile = $shm_hitalama_profile.current()

			switch( id ) {
				case 'js': return profile?.templates_js() ?? null
				case 'tsx': return profile?.templates_tsx() ?? null
				case 'sql': return profile?.templates_sql() ?? null
				case 'commands': return profile?.templates_commands() ?? null
			}

			return null
		}

	}

	export class $shm_hitalama_settings_agent_string extends $.$shm_hitalama_settings_agent_string {

		@ $mol_action
		autocomplete_unlock( next?: Event ) {
			if( next ) this.autocomplete_locked( false )
			return next ?? null
		}

	}

}
